import React, { Component } from 'react';
import moment from 'moment';
import styled from 'styled-components';

// Components
import SidePanelListItem from '../../../../../../components/SidePanelListItem';
import Icon from '../../../../../../components/Icon';
import LoadingIndicator from '../../../../../../components/LoadingIndicator';
import EmptyState from '../../../../../../components/EmptyState';
import AlertMessage from '../../../../../../components/AlertMessage';
import BorderedContainer from '../../../../../../components/BorderedContainer';

import InfoTitle from '../../components/InfoTitle';

import './styles.css';
import { Col, Row } from './styles';
import PeriodSymbol from '../../../../../../components/PeriodSymbol';

const StyledBorderedContainer = styled(BorderedContainer)`
  margin-top: 10px;
`;

const HistoryDate = styled.span`
  font-size: 14px;
  line-height: 16px;
  color: var(--dark-blue);
`;

const HistoryPeriod = styled.span`
  font-size: 12px;
  line-height: 14px;
  font-style: italic;
  color: var(--light-opacity-gray);
`;

const periods = {
  MORNING: 0,
  AFTERNOON: 1,
  NIGHT: 2,
  DAWN: 3,
};

export default class HistoryOverview extends Component {
  _renderDateDiff = (date1, date2) => {
    const dateDiff = moment(date2).diff(date1);

    const hoursDiff = moment.duration(-dateDiff).hours();
    const daysDiff = moment.duration(-dateDiff).days();
    const monthsDiff = moment.duration(-dateDiff).months();

    let diffString = '';

    if (monthsDiff > 0) {
      diffString = `${monthsDiff} meses, ${daysDiff} dias e ${hoursDiff} horas`;
    } else {
      diffString = `${daysDiff} dias e ${hoursDiff} horas`;
    }

    if (daysDiff === 0 && monthsDiff === 0) {
      diffString = `${hoursDiff} horas`;
    }

    return diffString;
  };

  _renderDeviation = (initialDate, lastDate) => {
    const isLate = moment(lastDate).isAfter(initialDate);
    const momentDiffDuration = isLate
      ? moment.duration(moment(lastDate).diff(initialDate))
      : moment.duration(moment(initialDate).diff(lastDate));

    if (isLate) {
      return (
        <div className="NFDetailListItem__Desc-deviation NFDetailListItem__Desc-deviation--downward">
          <Icon name="arrow_upward" />
          {momentDiffDuration.humanize()}
          <div className="NFDetailListItem__Desc-deviation-exact">
            {`${momentDiffDuration.days()}d ${momentDiffDuration.hours()}h ${momentDiffDuration.minutes()}m`}
          </div>
        </div>
      );
    }

    return (
      <div className="NFDetailListItem__Desc-deviation NFDetailListItem__Desc-deviation--upward">
        <Icon name="arrow_downward" />
        {moment.duration(moment(initialDate).diff(lastDate)).humanize()}
        <div className="NFDetailListItem__Desc-deviation-exact">
          {`${momentDiffDuration.days()}d ${momentDiffDuration.hours()}h ${momentDiffDuration.minutes()}m`}
        </div>
      </div>
    );
  };
  
  _getPeriodName = (periodCode) => {
    switch (periodCode) {
      case periods.MORNING:
        return 'MORNING';

      case periods.AFTERNOON:
        return 'AFTERNOON';

      case periods.NIGHT:
        return 'NIGHT';

      case periods.DAWN:
        return 'DAWN';

      default:
        return '';
    }
  }

  render() {
    const { data, isFetching, hasError } = this.props;

    return (
      <div className="TrackingDetailsInfo__NFMetaProps">
        <InfoTitle>Previsão</InfoTitle>
        <StyledBorderedContainer>
          {/* ====================== */}
          {/*     ERROR STATE        */}
          {/* ====================== */}
          {hasError && !isFetching && (
            <AlertMessage
              actionText="Tentar novamente"
              message="Ocorreu um erro"
              onRetry={this.props.onRetry}
              error
            />
          )}

          {/* ====================== */}
          {/*     EMPTY STATE        */}
          {/* ====================== */}
          {data.length === 0 && !isFetching && !hasError && (
            <Row>
              <Col xs12 sm4 md12>
                <SidePanelListItem title="Previsão Inicial">
                  <EmptyState noBorder message="Nenhum dado encontrado" />
                </SidePanelListItem>
              </Col>
              <Col xs12 sm4 md12>
                <SidePanelListItem className="HistoryOverview__detail-list-item--last-item" title="Última previsão">
                  <EmptyState noBorder message="Nenhum dado encontrado" />
                </SidePanelListItem>
              </Col>
              {/* <Col xs12 sm4 md12>
                <SidePanelListItem title="Desvio">
                  <EmptyState noBorder message="Nenhum dado encontrado" />
                </SidePanelListItem>
              </Col> */}
            </Row>
          )}

          {/* ====================== */}
          {/*     LOADING STATE      */}
          {/* ====================== */}
          {isFetching && <LoadingIndicator theme="dark" text="Carregando..." />}

          {/* ====================== */}
          {/*     NORMAL STATE       */}
          {/* ====================== */}
          {!isFetching && data.length > 0 && !hasError && (
            <Row>
              <Col xs6 sm4 md12>
                <SidePanelListItem  title="Previsão Inicial">
                  {data.length > 0 && (
                    <React.Fragment>
                      <HistoryDate>
                        {moment(data[data.length - 1].previewDate).format(
                          'DD/MM/YYYY'
                        )}{' '}
                        <PeriodSymbol period={this._getPeriodName(data[data.length - 1].period)} />
                        <br />
                      </HistoryDate>
                      <HistoryPeriod>
                        {this._renderDateDiff(
                          data[data.length - 1].previewDate,
                          this.props.orderDate,
                        )}
                      </HistoryPeriod>
                    </React.Fragment>
                  )}
                </SidePanelListItem>
              </Col>
              <Col mb0 xs6 sm4 md12>
                <SidePanelListItem className="HistoryOverview__detail-list-item--last-item" title="Última previsão">
                  {data.length > 0 && (
                    <React.Fragment>
                      <HistoryDate>
                        {moment(data[0].previewDate).format(
                          'DD/MM/YYYY',
                        )}{' '}
                        <PeriodSymbol period={this._getPeriodName(data[0].period)} />
                        <br />
                      </HistoryDate>
                      <HistoryPeriod>
                        {this._renderDateDiff(
                          data[0].previewDate,
                          this.props.orderDate,
                        )}
                      </HistoryPeriod>
                    </React.Fragment>
                  )}
                </SidePanelListItem>
              </Col>
              {/* <Col xs12 sm4 md12>
                <SidePanelListItem
                  className="HistoryOverview__detail-list-item--last-item"
                  title="Desvio"
                >
                  {data.length > 0 &&
                    this._renderDeviation(
                      data[data.length - 1].previewDate,
                      data[0].previewDate,
                    )}
                </SidePanelListItem>
              </Col> */}
            </Row>
          )}
        </StyledBorderedContainer>
      </div>
    );
  }
}
